export default __webpack_public_path__ + "static/media/file_00003.26aaba56.pdf";